import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Card, Placeholder } from 'semantic-ui-react'
import { SEARCH_ACTIONS } from '../actions/search'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Empty, Worker } from '../components'

const { app, roles, newEl, roleEdit } = routes

class Roles extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            items: 10,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return nextProps
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { deleteWorker } = this.state
        let { organization } = this.props
        if (
            this.state.page !== prevState.page ||
            this.state.items !== prevState.items ||
            (deleteWorker.fetching !== prevState.deleteWorker.fetching && !deleteWorker.fetching) ||
            organization.data !== prevProps.organization.data
        ) {
            this.state.network.getWorkerList(this.state.search.data)
        } else if (this.state.search !== prevState.search) {
            this.state.network.getWorkerList(this.state.search.data)
        }
    }

    next() {
        this.setState({
            page: this.state.page + 1,
        })
    }

    prev() {
        if (this.state.page === 0) return

        this.setState({
            page: this.state.page - 1,
        })
    }

    componentDidMount() {
        let { login } = this.props

        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        let extraTools = []

        if (user && !!user.manage_job) {
            extraTools.push({
                name: 'Crea nuovo impiegato',
                icon: 'add',
                action: () => {
                    this.props.history.push(route_from(app, roles, newEl, roleEdit))
                },
            })
        }

        this.props.toolbarResult([
            ...extraTools,
            // Not paginated yer
            // {
            // 	name: '',
            // 	icon: 'arrow left',
            // 	position: 'right',
            // 	action: () => {
            // 		this.prev()
            // 	}
            // },
            // {
            // 	name: '',
            // 	icon: 'arrow right',
            // 	position: 'none',
            // 	action: () => {
            // 		this.next()
            // 	}
            // }
        ])

        this.state.network.getWorkerList(this.state.search.data)
    }

    renderWorker(key, role) {
        return <Worker type="full" key={`role_${role.roleId}`} role={role} />
    }

    render() {
        let content = <div />

        if (this.state.fetching) {
            let placeholders = []
            for (let i = 0; i < 3; i++) {
                placeholders.push(
                    <Card style={{ width: '100%' }}>
                        <Card.Content>
                            <Placeholder>
                                <Placeholder.Header image>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Header>
                                <Placeholder.Paragraph>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Paragraph>
                            </Placeholder>
                        </Card.Content>
                    </Card>
                )
            }
            content = (
                <View noflex fullw column>
                    {placeholders}
                </View>
            )
        } else if (this.state.roles.data && this.state.roles.data.length > 0) {
            content = this.state.roles.data.map((value, index) => {
                return this.renderWorker(index, value)
            })
        } else {
            content = <Empty />
        }

        return (
            <View fullw fullh column style={{ paddingLeft: 20, paddingRight: 20 }}>
                {content}
            </View>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { getWorkerList, search, deleteWorker, organization, login } = state

    return {
        roles: getWorkerList.data,
        fetching: getWorkerList.fetching,
        deleteWorker,
        search,
        login,
        organization,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),

        searchRequest: (result) => SEARCH_ACTIONS.request(result, dispatch),
        searchResult: (result) => SEARCH_ACTIONS.result(result, dispatch),
        searchError: (result) => SEARCH_ACTIONS.error(result, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(Roles)))
